import React, {PureComponent} from 'react';
import './ChooseContactTypeComponent.less';
import {RadioButton, RadioGroup} from '@homeaway/react-form-components';
import {ButtonPrimary} from '@homeaway/react-buttons';
import mfaClient from '../../util/mfaClient';

class ChooseContactTypeComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            contactType: '',
            phoneList: [],
            choosenPhone: {},
            numberOfSecurityPhones: 0
        };
    }

    componentDidMount() {
        this.retrievePhones(this.props.challengeTicket);
    }

    retrievePhones = (challengeTicket) => {
        let phonesPromise = mfaClient.getPhones({challengeTicket});
        phonesPromise.then((data) => {
            this.setState({phoneList: data.phones, numberOfSecurityPhones: data.numberOfSecurityPhones});
        }).catch(() => {
            // gets called again when clicking back button on following components
            // If it fails & we have phones already, maybe use them?
            if (!this.state.phoneList || this.state.phoneList.length === 0) {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
            }
        });
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    };

    changeSuccess = () => {
        const {updatePage, setContactType, setPhoneNumber, setNumberOfSecurityPhones} = this.props;
        setContactType(this.state.contactType);
        setNumberOfSecurityPhones(this.state.numberOfSecurityPhones);
        if (this.state.phoneList.length < 1) {
            this.props.handleError(this.props.lingua.read('error.generic'), '');
        } else if (this.state.phoneList.length === 1) {
            const phoneNumber = this.state.phoneList[0];
            setPhoneNumber(phoneNumber);
            this.props.setPhonesList(this.state.phoneList);
            this.sendChallenge();
        } else {
            this.props.setPhonesList(this.state.phoneList);
            updatePage('choosePhone');
        }
    };

    sendChallenge = () => {
        mfaClient.challenge(this.props.challengeTicket, this.state.contactType, this.state.phoneList[0])
            .then(() => {
                this.props.updatePage('verifyCode');
            }).catch(() => {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
            });
    }

    render() {
        const contactTypeSelected = !this.state.contactType ? true : false;
        return (
            <div className="Identity">
                <div className="title">
                    <p>{this.props.lingua.read('lex.owner.identity.subtitle')}</p>
                </div>
                <div className="message">
                    <p>{this.props.lingua.read('lex.owner.identity.message')}</p>
                </div>
                <div className="radios">
                    <RadioGroup id="contactType" name="contactType" ariaLabel="hello">
                        <RadioButton
                            id="smsContact"
                            label={this.props.lingua.read('lex.owner.identity.sms')}
                            value="SMS"
                            checked={this.state.contactType === 'SMS'}
                            onChange={this.handleChange}
                        />
                        <RadioButton
                            id="callContact"
                            label={this.props.lingua.read('lex.owner.identity.call')}
                            value="CALL"
                            checked={this.state.contactType === 'CALL'}
                            onChange={this.handleChange}
                        />
                    </RadioGroup>
                </div>
                <div className="radiosnext">
                    <ButtonPrimary id="contactNext" type="button" label={this.props.lingua.read('lex.owner.button.next')} disabled={contactTypeSelected} onClick={this.changeSuccess}/>
                </div>
            </div>
        );
    }
}

export default ChooseContactTypeComponent;
